<template>
  <Modal
    class="create-update-modal"
    :mask-closable="false"
    :closable="false"
    :title="actionText + '代理商商品'"
    width="800px"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="代理商商品ID:" prop="agentCommodityId">
            <InputNumber
              style="width: 100%;"
              v-model="handleForm.agentCommodityId"/>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="选择商品:" prop="commodityId">
            <Select
              v-model.trim="handleForm.commodityId"
              placeholder="请选择或输入查询"
              filterable
              clearable
              remote
              :remote-method="getCommodity"
              :loading="commodityLoading"
              @on-query-change="changeCommodityQuery"
              @on-change="commodityQueryChange"
              @on-select="selectCommodity"
              @on-clear="clearCommodity">
              <Option v-for="(option, index) in commodityOptions" :value="option.value" :key="index">{{option.label}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="销售价:" prop="salePrice">
            <InputNumber
              style="width: 100%;"
              :min="0"
              v-model="handleForm.salePrice"
              :formatter="value => `${value}元`"
              :parser="value => value.replace('元', '')" />
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="销售折扣:" prop="discount">
            <InputNumber
              style="width: 100%;"
              :max="100"
              :min="0"
              v-model="handleForm.discount"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')" />
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="税点:" prop="taxPoint">
            <InputNumber
              style="width: 100%;"
              :max="20"
              :min="0"
              v-model="handleForm.taxPoint"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')" />
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="对账规则:" prop="reconciliationRules">
            <Select v-model="handleForm.reconciliationRules" style="width: 100%;">
              <Option v-for="item in reconciliation1" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'
export default {
  name: 'AgentCommodityCreateUpdate',
  data () {
    return {
      modal: false,
      loading: false,
      action: 'create',
      dataIndex: null,
      commodityLoading: false,
      commodityOptions: [],
      reconciliation1: [{
        value: 0,
        label: '订购即对账'
      },
      {
        value: 1,
        label: '核销后对账'
      }
      ],
      handleForm: {
        agentCommodityId: null,
        agentId: null,
        commodityId: null,
        salePrice: 0,
        discount: 0,
        taxPoint: 0,
        reconciliationRules: null
      },
      handleValidate: {
        commodityId: [
          { required: true, whitespace: true, message: '请选择代理的商品', trigger: 'change' }
        ],
        salePrice: [
          { required: true, whitespace: true, type: 'number', message: '请输入销售价', trigger: 'blur' }
        ],
        discount: [
          { required: true, whitespace: true, type: 'number', message: '请输入销售折扣', trigger: 'blur' }
        ],
        taxPoint: [
          { required: true, whitespace: true, type: 'number', message: '请输入税点', trigger: 'blur' }
        ],
        reconciliationRules: [
          { required: true, whitespace: true, type: 'number', message: '请选择对账规则', trigger: 'change' }
        ]
      },
      queryCommodity: null,
      isSelectCommodity: false,
      isClearCommodity: false
    }
  },
  computed: {
    actionText () {
      return this.action === 'create' ? '新增' : '编辑'
    }
  },
  methods: {
    show (action = 'create', data = {}, index) {
      // 清空搜索框
      this.queryCommodity = null
      this.commodityQuery()
      this.action = action
      // this.handleForm.agentId = data.agentId
      this.handleForm.agentId = this.action === 'update' ? data.agentId : data.id
      if (this.action === 'update') {
        this.handleForm = {
          ...this.handleForm,
          commodityId: data.commodityId,
          salePrice: data.salePrice,
          discount: data.discount,
          taxPoint: data.taxPoint,
          agentCommodityId: data.id,
          reconciliationRules: data.reconciliationRules
        }
        this.commodityOptions = [{
          value: data.commodityId,
          label: data.commodityName
        }]
        this.dataIndex = index
      }
      this.modal = true
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.handleForm.agentCommodityId = ''
      this.handleForm.agentId = ''
      this.handleForm.commodityId = ''
      this.handleForm.reconciliationRules = ''
      this.dataIndex = null
      this.loading = false
      this.modal = false
      this.queryCommodity = null
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let queryParams = {
        ...this.handleForm
      }
      let submitApi = api.agent.agentCommodityCreateUpdate
      // if (this.action === 'create') {
      //   delete queryParams.agentCommodityId
      // }
      this.loading = true
      submitApi(queryParams).then(res => {
        this.$emit('success', this.action, {
          ...queryParams
        }, this.dataIndex)
        this.$Message.success(this.actionText + '成功！')
        this.hide()
        this.queryCommodity = ''
      }).catch(err => {
        this.$Message.error({
          content: this.actionText + '失败：' + err.message,
          duration: 2
        })
      }).then(() => {
        this.loading = false
      })
    },
    // 节流
    throttle (fn, delay, val) {
      clearTimeout(fn.timeoutId)
      fn.timeoutId = setTimeout(function () {
        fn.call(val)
      }, delay)
    },
    // 商品输入框
    changeCommodityQuery (val) {
      this.queryCommodity = val
      if (!this.isSelectCommodity) {
        this.throttle(this.commodityQuery, 500)
      }
    },
    // 远程获取商品
    getCommodity () {
      // this.throttle(this.commodityQuery, 500)
    },
    commodityQuery () {
      this.commodityLoading = true
      api.commodity.commodityList({
        pageNum: 1,
        pageSize: 100,
        commodityName: this.queryCommodity,
        sourceType: 0,
        useState: 1
      }).then(res => {
        const result = res.data.records || []
        this.commodityOptions = []
        result.map(item => {
          this.commodityOptions.push({
            value: item.id,
            label: item.commodityName + '(' + item.labelName + ')'
          })
        })
      }).catch(() => {
        // tips
        this.commodityOptions = []
      }).then(() => {
        this.commodityLoading = false
      })
    },
    commodityQueryChange () {
      if (!this.isSelectCommodity) {
        // this.getData()
        // console.log('1111')
      }
    },
    // 选中
    selectCommodity (val) {
      this.queryCommodity = val.value
      this.isSelectCommodity = true
      this.isClearCommodity = false
    },
    // 清除
    clearCommodity () {
      this.isClearCommodity = true
    }
  }
}
</script>
